export default __webpack_public_path__ + "static/media/logo-app.4354cd37.png";